<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="80px">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate, getLastDates } from '@/utils'
import { getUserSourceStat2 } from '@/api/user/user_info'

export default {
  name: 'BotStat',
  props: {
    typ: {
      type: Number,
      default: 14
    },
    reason: {
      type: String,
      default: '-'
    }
  },
  data() {
    return {
      rewardMap: {
        14: '金币',
        15: '体力'
      },
      reasonMap: {
        '+': '产出',
        '-': '消耗'
      },
      queryParams: {
        startDate: '',
        endDate: '',
        country: '+',
        level: 14
      },
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }
    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(0)
    }
    this.getTables()
  },
  methods: {
    handleQuery() {

    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: '建筑花费'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
    },
    getTables() {
      this.queryParams.level = this.typ
      this.queryParams.country = this.reason
      getUserSourceStat2(this.queryParams).then(res => {
        const data = res.data
        const uids = {}
        const dateData = {}
        const date = {}
        for (const i in data) {
          const val = data[i]
          uids[val.uid] = val.uid
          date[val.date] = val.date
          if (dateData[val.uid] === undefined) {
            dateData[val.uid] = []
          }
          dateData[val.uid].push(val.num)
        }

        for (const i in dateData) {
          const val = dateData[i]
          const temp = {
            name: i,
            data: val,
            type: 'line',
            smooth: true,
            label: {
              // show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            },
            itemStyle: {
              // 设置柱子宽度
              barWidth: '20%'
            }
          }

          // if (this.typ === 15) {
          //   temp.type = 'line'
          //   temp.itemStyle = {}
          // }

          this.option.series.push(temp)
        }

        for (const i in uids) {
          this.option.legend.data.push(uids[i])
        }

        for (const i in date) {
          this.option.xAxis.data.push(dateStrTodate(date[i]))
        }
        this.option.title.text = this.rewardMap[this.typ] + this.reasonMap[this.reason]
        this.chart.setOption(this.option, true)
      })
    }
  }

}
</script>

<style scoped>

</style>
